export default __webpack_public_path__ + "static/media/curvedpics.9e1381aa.png";